import { render } from "./document-template-modal.vue?vue&type=template&id=aa2c1a66"
import script from "./document-template-modal.vue?vue&type=script&lang=js"
export * from "./document-template-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__